import { getParam } from '../../helpers/parameters'

export const apiSendEmail = async (
  to,
  message,
  name,
  fromAddress,
  sub,
  excludeEmail
) => {
  const [mailerApiUrl, mailerApiToken] = await Promise.all([
    getParam('mailerApiUrl'),
    getParam('mailerApiToken')
  ])
  const body = JSON.stringify({
    name: name || 'AgentAI',
    email: fromAddress || 'no-reply@results-cx.com',
    toEmail: to,
    subject: sub || `Your requested solution from ${name || 'AgentAI'}`,
    message,
    excludeEmail
  })

  return fetch(mailerApiUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer: ${mailerApiToken}`
    },
    body
  })
    .then((response) => response)
    .catch((error) => error)
}
